import React from 'react';
import { Dialog, DialogContent, CircularProgress } from '@material-ui/core';

export default function BlockingLoader({ children }) {
  return (
    <Dialog
      open
      style={{ top: '210px' }}
      BackdropProps={{ style: { top: '210px', backgroundColor: 'rgba(255, 255, 255, 0.5)' } }}
      PaperProps={{
        style: { textAlign: 'center', color: 'black', fontSize: '16px' },
      }}
    >
      <DialogContent>
        <div style={{ marginBottom: '15px' }}>{children}</div>
        <CircularProgress />
      </DialogContent>
    </Dialog>
  );
}
